import { createSlice } from '@reduxjs/toolkit';

import { getElhaghiyehHayeSadereh, printElhaghiyehMasooliatMadani } from './action';
import { IElhaghiyehSaderehState } from './model';

const initialState: IElhaghiyehSaderehState = {
  elhaghiyehHayeSadereh: {
    loading: false,
    data: [],
  },
  print: {
    loading: false,
  },
};

export const elhaghiyehHayeSaderehSlice = createSlice({
  name: 'masooliatMadani/elhaghiyehHayeSadereh',
  initialState,
  reducers: {
    clearElhaghiyehHayeSadereh: (state) => {
      state.elhaghiyehHayeSadereh = initialState.elhaghiyehHayeSadereh;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getElhaghiyehHayeSadereh.pending, (state) => {
        state.elhaghiyehHayeSadereh.loading = true;
      })
      .addCase(getElhaghiyehHayeSadereh.fulfilled, (state, action) => {
        state.elhaghiyehHayeSadereh.loading = false;
        state.elhaghiyehHayeSadereh.data = action.payload;
      })
      .addCase(getElhaghiyehHayeSadereh.rejected, (state) => {
        state.elhaghiyehHayeSadereh.loading = false;
      });
    builder
      .addCase(printElhaghiyehMasooliatMadani.pending, (state) => {
        state.print.loading = true;
      })
      .addCase(printElhaghiyehMasooliatMadani.fulfilled, (state) => {
        state.print.loading = false;
      })
      .addCase(printElhaghiyehMasooliatMadani.rejected, (state) => {
        state.print.loading = false;
      });
  },
});

export const { clearElhaghiyehHayeSadereh } = elhaghiyehHayeSaderehSlice.actions;

export default elhaghiyehHayeSaderehSlice.reducer;
